class MediaHero extends HTMLElement {
  constructor() {
    super();
    this.video = null;
    this.toggleBtn = null;
  }

  connectedCallback() {
    this.video = this.querySelector('video, .media-hero__video');
    this.toggleBtn = this.querySelector('[data-media-hero-sound]');

    if (this.video) {
      this.video.muted = true;
      this.video.setAttribute('muted', '');
      this.video.playsInline = true;

      const playPromise = this.video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }

    if (this.toggleBtn && this.video) {
      this.toggleBtn.addEventListener('click', this.handleToggle.bind(this));
    }
  }

  handleToggle(event) {
    event.preventDefault();
    if (!this.video) return;

    const nextMuted = !this.video.muted;
    this.video.muted = nextMuted;

    if (nextMuted) {
      this.removeAttribute('data-unmuted');
      this.toggleBtn.setAttribute('aria-pressed', 'false');
      this.toggleBtn.setAttribute('aria-label', 'Activer le son');
    } else {
      this.setAttribute('data-unmuted', 'true');
      this.toggleBtn.setAttribute('aria-pressed', 'true');
      this.toggleBtn.setAttribute('aria-label', 'Couper le son');

      const playPromise = this.video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          this.video.muted = true;
          this.removeAttribute('data-unmuted');
          this.toggleBtn.setAttribute('aria-pressed', 'false');
        });
      }
    }
  }
}

if (!customElements.get('media-hero')) {
  customElements.define('media-hero', MediaHero);
}
